import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  signal,
  TemplateRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModalServiceService } from './modal-service.service';
import { Modal } from './modal.interface';
import { CloseIconComponent } from '@kuiper/icons';

@Component({
  selector: 'lib-modal',
  imports: [NgTemplateOutlet, CloseIconComponent],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ModalComponent {
  modalService = inject(ModalServiceService);

  modal = computed<Modal>(() => ({
    ...this.modalService.modalContent(),
    width: this.modalService.modalContent().width || '30',
  }));

  content = signal<TemplateRef<unknown> | null>(null);

  constructor() {
    effect(() => {
      const modalContent = this.modalService.modalContent();
      this.content.set(modalContent.customizeContent as TemplateRef<unknown>);
    });
  }

  closeModal() {
    this.modalService.modalContent.set({ isOpen: false });
    if (this.modal().formGroup) {
      (<FormGroup>this.modal().formGroup).reset();
    }
  }
}
